<template>
    <div>
        <div class="columns">

            <div class="column">

                <b-field
                    expanded
                    :label="$t(`students.type.title`)">
                    <b-select
                        @input="onStudentTypeChange"
                        expanded
                        :disabled="isDuplicate"
                        v-model="item.student_type">
                        <option
                            v-for="option in [`bachelor`, `master`, `graduate`]"
                            :value="option"
                            :key="option">
                            {{ $t(`students.type.${option}`) }}
                        </option>
                    </b-select>
                </b-field>

            </div>
            
            <div class="column">

                <b-field
                    expanded
                    label="Учебный год">
                    <b-select
                        @input="onEnrollemntYearChange"
                        expanded
                        v-model="item.enrollment_year">
                        <option
                            v-for="option in years"
                            :value="option.enrollment_year"
                            :key="option.enrollment_year">
                            {{ option.title }}
                        </option>
                    </b-select>
                </b-field>

            </div>

        </div>

        <div class="columns" v-show="!isDuplicate">
            
            <div class="column">

                <b-field
                    expanded
                    :label="$t(`semesters.title`)">

                    <b-field>

                        <b-radio-button
                            @input="onSemesterSelect(semester)"
                            class="is-expanded is-fullwidth"
                            v-for="semester in semesters"
                            :key="semester.number"
                            v-model="item.semester"
                            :native-value="semester.number"
                            :disabled="!semester.exists">
                            <span>{{ semester.number }}</span>
                        </b-radio-button>

                    </b-field>
                    
                </b-field>

            </div>

        </div>
    </div>
</template>
<script>
import toasts from "../../mixins/toasts";
import messages from "../../mixins/messages";

export default Vue.extend({
  props: {
    isDuplicate: {
      type: Boolean
    },
    preset: {
      type: Object
    },
    currentAcademicYear: {
      type: [Number]
    },
    semesterParity: {
      type: [String]
    }
  },
  mixins: [toasts, messages],
  data() {
    return {
      item: {
        student_type: "bachelor",
        enrollment_year: null,
        semester: null
      }
    };
  },
  computed: {
    years() {
      let years = [];
      let forward = 2;
      let year = this.currentAcademicYear;

      for (let i = forward; i >= 0; i--) {
        years.push({
          enrollment_year: year + i,
          title: `${year + i} / ${year + i + 1}`
        });
      }

      return years;
    },
    semesters() {
      let semesters = [];
      for (let semester = 1; semester <= 8; semester++) {
        let exists = true;
        let even = semester % 2 == 0;

        if (semester > 4 && this.item.student_type != "bachelor") {
          exists = false;
        }

        semesters.push({
          exists: exists,
          number: semester,
          enrollment_year:
            this.currentAcademicYear - Math.floor((semester - 1) / 2)
        });
      }

      return semesters;
    },
    courses() {
      let courses = [];

      for (let course = 0; course <= 4; course++) {
        if (course > 2 && this.item.student_type != "bachelor") {
          break;
        }
        courses.push({
          enrollment_year: this.currentAcademicYear - (course - 1),
          course: course
        });
      }

      return courses;
    }
  },
  created() {
    let currentYear = this.$moment().year();
    let index = _.findIndex(this.years, {
      enrollment_year: this.currentAcademicYear
    });
    if (index > -1) {
      this.item.enrollment_year = this.years[index].enrollment_year;
    } else {
      this.item.enrollment_year = _.last(this.years).enrollment_year;
    }

    if (this.preset) {
      this.item = _.merge(this.item, this.preset);
    }
  },
  methods: {
    onEnrollemntYearChange() {
      this.modify();
    },
    onStudentTypeChange() {
      this.item.semester = null;
    },
    onSemesterSelect(semester) {
      this.modify();
    },
    populate(data) {
      this.item = data;
      this.modify();
    },
    modify() {
      this.$emit("modified", this.item);
    },
    save: function() {
      return new Promise((resolve, reject) => {
        // First validate the data.
        axios
          .post(`/api/schedule/validate`, this.item)
          .then(response => {
            // If entered data is valid, try to create new group.
            axios
              .post(`/api/schedule`, this.item)
              .then(response => {
                resolve(response.data);
              })
              .catch(error => {
                switch (error.response.status) {
                  case 403: {
                    this.toast(
                      "warning",
                      "Создание расписания с такими параметрами недоступно"
                    );
                    break;
                  }
                  default: {
                    this.toast("error", "@select-all");
                  }
                }
                reject();
              });
          })
          .catch(error => {
            // Otherwise catch the error and display it to the user.
            switch (error.response.status) {
              case 409: {
                this.toast(
                  "warning",
                  "Расписание для этого курса в этом семестре уже существует"
                );
                break;
              }
              default: {
                this.toast("error", "@select-all");
              }
            }
            this.loading = false;
            reject();
          });
      });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/models/Schedule.vue